import { CalendarHolidays, Id, Identifiable, Resource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getPersonalCalendarHolidays(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>) =>
    httpClient
      .sendHttpRequest<Identifiable<CalendarHolidays>>({
        endpoint: `/resources/${resource.uuid}/calendarHolidays`,
        method: HttpMethods.GET,
      })
      .then((calendarHolidays) => calendarHolidays);
}

export { getPersonalCalendarHolidays };
